const toggleViewSettingsShowRelationshipTypes = (state, typeIds) => {
  return state.update("showRelationshipTypes", list => {
    let newList = list;
    typeIds.forEach(tId => {
      const findIndex = newList.findIndex(id => id === tId);
      if (findIndex >= 0) {
        newList = newList.delete(findIndex);
      } else {
        newList = newList.push(tId);
      }
    });
    return newList;
  });
};

export { toggleViewSettingsShowRelationshipTypes };
